import { connect } from 'react-redux';
import { useCallback, useEffect } from 'react';

import { trackEvent } from 'helpers/analytics';
import MelodyCarousel from 'components/common/MelodyCarousel';
import MelodyCardCategory from 'components/common/melodyCard/MelodyCardCategory';

import css from 'styles/components/landing/melodyPersonalizedCategories.scss';

export const MelodyPersonalizedCategories = ({ firstName, slotName, slotDetails, slotIndex, onLandingComponentClick, shouldLazyLoad }) => {
  const { categories, monetateId } = slotDetails;
  const handleClick = useCallback(e => {
    trackEvent('TE_PERSONALIZED_CATEGORIES_CLICK', `slotIndex:${slotIndex}`);
    onLandingComponentClick(e);
  }, [onLandingComponentClick, slotIndex]);

  useEffect(() => {
    trackEvent('TE_PERSONALIZED_CATEGORIES_VIEW', `slotIndex:${slotIndex}`);
  }, [slotIndex]);

  if (categories?.length) {
    return (
      <div className={css.wrap} data-slot-id={slotName} data-monetate-id={monetateId}>
        <h2 className={css.heading}>
          {Boolean(firstName) && `${firstName}, `}You Might Like These Categories.
        </h2>
        <MelodyCarousel>
          {categories.map(category => {
            const { product: { styleId } } = category;
            return <MelodyCardCategory
              cardData={category}
              onLandingComponentClick={handleClick}
              key={styleId}
              eventLabel="melodyPersonalizedCategories"
              melodyCardTestId="melodyPersonalizedCategories"
              shouldLazyLoad={shouldLazyLoad} />;
          })}
        </MelodyCarousel>
      </div>
    );
  } else {
    return null;
  }
};

function mapStateToProps(state) {
  return {
    firstName: state.holmes?.firstName
  };
}

export default connect(mapStateToProps)(MelodyPersonalizedCategories);
